<section>
  <div class="uk-flex uk-flex-middle uk-text-bold uk-margin-bottom"><span class="material-symbols-outlined uk-margin-small-right">chat</span> Create New Field</div>

  <div class="uk-margin-bottom">
    <div class="uk-text-muted uk-text-small uk-margin-bottom">Text field</div>
    <a class="uk-flex uk-flex-middle uk-text-decoration-none" (click)="addField(FieldType.string)">
      <span class="material-symbols-outlined uk-margin-small-right">horizontal_rule</span>Simple input
    </a>
    <a class="uk-flex uk-flex-middle uk-text-decoration-none" (click)="addField(FieldType.largeText)">
      <span class="material-symbols-outlined uk-margin-small-right">dehaze</span>Text area
    </a>
    <a class="uk-flex uk-flex-middle uk-text-decoration-none" (click)="addField(FieldType.richText)">
      <span class="material-symbols-outlined uk-margin-small-right">data_object</span>Rich text
    </a>
    <a class="uk-flex uk-flex-middle uk-text-decoration-none" (click)="addField(FieldType.url)">
      <span class="material-symbols-outlined uk-margin-small-right">http</span>Url
    </a>
    <a class="uk-flex uk-flex-middle uk-text-decoration-none" (click)="addField(FieldType.email)">
      <span class="material-symbols-outlined uk-margin-small-right">contact_mail</span>Email
    </a>
    <a class="uk-flex uk-flex-middle uk-text-decoration-none" (click)="addField(FieldType.phone)">
      <span class="material-symbols-outlined uk-margin-small-right">call</span>Phone number
    </a>
  </div>

  <div class="uk-margin-bottom">
    <div class="uk-text-muted uk-text-small uk-margin-bottom">Choices</div>
    <a class="uk-flex uk-flex-middle uk-text-decoration-none" (click)="addField(FieldType.checkbox)">
      <span class="material-symbols-outlined uk-margin-small-right">check_box</span>Check box
    </a>
    <a class="uk-flex uk-flex-middle uk-text-decoration-none" (click)="addField(FieldType.radio)">
      <span class="material-symbols-outlined uk-margin-small-right">radio_button_checked</span>Radio
    </a>
    <a class="uk-flex uk-flex-middle uk-text-decoration-none" (click)="addField(FieldType.select)">
      <span class="material-symbols-outlined uk-margin-small-right">arrow_drop_down_circle</span>Select
    </a>
  </div>

  <div class="uk-margin-bottom">
    <div class="uk-text-muted uk-text-small uk-margin-bottom">Number</div>
    <a class="uk-flex uk-flex-middle uk-text-decoration-none" (click)="addField(FieldType.number)">
      <span class="material-symbols-outlined uk-margin-small-right">numbers</span>Number input
    </a>
  </div>

  <div class="uk-margin-bottom">
    <div class="uk-text-muted uk-text-small uk-margin-bottom">Date</div>
    <a class="uk-flex uk-flex-middle uk-text-decoration-none" (click)="addField(FieldType.date)">
      <span class="material-symbols-outlined uk-margin-small-right">calendar_month</span>Date input
    </a>
  </div>

  <div class="uk-margin-bottom">
    <div class="uk-text-muted uk-text-small uk-margin-bottom">Group</div>
    <a class="uk-flex uk-flex-middle uk-text-decoration-none" (click)="addField(FieldType.composite)">
      <span class="material-symbols-outlined uk-margin-small-right">ballot</span>Group
    </a>
  </div>

<!--  <a class="uk-flex uk-flex-middle uk-text-decoration-none" (click)="addField(FieldType.checkbox)">-->
<!--    <span class="material-symbols-outlined uk-margin-small-right">select_check_box</span>Check box-->
<!--  </a>-->


</section>
